const MAX_PAST_FYEARS = 1

/** Ahead of the current fYear, only to the fYears the user may switch to (`useAvailableFYears`). */
export const getCockpitFYearBounds = (currentFYear: number, availableFYears: number[] = []) => ({
  minFYear: currentFYear - MAX_PAST_FYEARS,
  maxFYear: Math.max(currentFYear, ...availableFYears),
})
